import { valeurSelonUnite } from '@/utils/restitution'

export const CHARGES_FIXES = [
  {
    cle: 'mecanisation',
    libelle: 'Mécanisation',
    sousPostes: [
      { cle: 'carburant', libelle: 'Carburants - lubrifiants' },
      { cle: 'travauxParTiers', libelle: 'Travaux par tiers - CUMA' },
      { cle: 'entretien', libelle: 'Entretien - réparation' },
      { cle: 'remboursementCapitalMateriel', libelle: 'Remboursement capital matériel' }
    ]
  },
  {
    cle: 'batiment',
    libelle: 'Bâtiments et installations',
    sousPostes: [
      { cle: 'entretien', libelle: 'Entretien - réparations' },
      { cle: 'location', libelle: 'Location - mise à disposition' },
      { cle: 'irrigation', libelle: 'Irrigation' },
      { cle: 'energie', libelle: 'Eau, gaz, électricité' },
      { cle: 'remboursementCapitalBatiment', libelle: 'Remboursement capital bât. et inst.' }
    ]
  },
  {
    cle: 'foncier',
    libelle: 'Foncier',
    sousPostes: [
      { cle: 'location', libelle: 'Location - mise à disposition' },
      { cle: 'entretienFoncier', libelle: 'Entretien foncier' },
      { cle: 'remboursementCapitalFoncier', libelle: 'Remboursement capital' }
    ]
  },
  {
    cle: 'mainOeuvre',
    libelle: 'Main d\'œuvre',
    sousPostes: [
      { cle: 'salaires', libelle: 'Salaires et charges sociales' },
      { cle: 'chargesSociales', libelle: 'Charges sociales exploitant' },
      { cle: 'prelevementsPrives', libelle: 'Prélèvements privés' }
    ]
  },
  {
    cle: 'fraisDiversGestion',
    libelle: 'Autres charges fixes',
    sousPostes: [
      { cle: 'fraisGestion', libelle: 'Intermédiaires et honoraires' },
      { cle: 'assurances', libelle: 'Assurances' },
      { cle: 'fraisDivers', libelle: 'Divers (tél, frais postaux, impôts, transp.)' },
      { cle: 'remboursementsTresorerie', libelle: 'Remboursement capital trésorerie (BFR, consolidation)' },
      { cle: 'autresRemboursements', libelle: 'Remboursement capital autres' }
    ]
  },
  {
    cle: 'fraisFinanciers',
    libelle: 'Frais financiers',
    sousPostes: [
      { cle: 'creditCT', libelle: 'CT - agios' },
      { cle: 'creditLMT', libelle: 'Intérêts LMT' }
    ]
  }
]

export const CHARGES_VARIABLES = [
  {
    cle: 'semence',
    libelle: 'Semences',
    sousPostes: [
      { cle: 'semencesAchetees', libelle: 'Semences achetées' },
      { cle: 'semencesFermieres', libelle: 'Semences fermières' }
    ]
  },
  {
    cle: 'engrais',
    libelle: 'Engrais',
    sousPostes: [
      { cle: 'mineral', libelle: 'Minéral' },
      { cle: 'organique', libelle: 'Amendements organiques' },
      { cle: 'calcique', libelle: 'Amendements calciques' },
      { cle: 'oligoElements', libelle: 'Oligo-éléments - biostimulants' }
    ]
  },
  {
    cle: 'traitement',
    libelle: 'Traitements',
    sousPostes: [
      { cle: 'herbicide', libelle: 'Herbicides' },
      { cle: 'fongicide', libelle: 'Fongicides' },
      { cle: 'insecticide', libelle: 'Insecticides' },
      { cle: 'autre', libelle: 'Autres' }
    ]
  },
  {
    cle: 'divers',
    libelle: 'Divers',
    sousPostes: [
      { cle: 'ficelle', libelle: 'Ficelle' },
      { cle: 'autre', libelle: 'Autres' }
    ]
  }
]

export const AUTRES_PRODUITS = [
  {
    cle: 'aides',
    libelle: 'Aides',
    sousPostes: [
      { cle: 'aidesPACCouplees', libelle: 'Aides PAC couplées' },
      { cle: 'aidesPACDecouplees', libelle: 'Aides PAC découplées' },
      { cle: 'aidesPAC2emePilierICHN', libelle: 'ICHN' },
      { cle: 'aidesPAC2emePilierHorsICHN', libelle: '2ème pilier hors ICHN' },
      { cle: 'autresAides', libelle: 'Autres aides' }
    ]
  },
  {
    cle: 'autresProduits',
    libelle: 'Autres produits',
    sousPostes: [
      { cle: 'produitsFinanciers', libelle: 'Produits financiers' },
      { cle: 'indemniteAssurance', libelle: 'Indemnité d\'assurance' },
      { cle: 'autresProduits', libelle: 'Autres produits' }
    ]
  }
]

export const COPRODUITS = [
  { cle: 'coproduits', libelle: 'Co-produits', sousPostes: [] }
]

export const construireSection = (table, courante, evolution, groupe, unite) => {
  return table.map((bloc) => {
    const donnees = courante != null ? courante[bloc.cle] : null
    const donneesEvolution = evolution != null ? evolution[bloc.cle] : null
    const donneesGroupe = groupe != null ? groupe[bloc.cle] : undefined

    const aDesSousPostes = bloc.sousPostes.length > 0
    const champDe = (source) => {
      if (source == null) {
        return null
      }
      return aDesSousPostes ? source.total : source
    }

    return {
      cle: bloc.cle,
      libelle: bloc.libelle,
      champ: champDe(donnees),
      evolution: pourcentageEvolution(champDe(donneesEvolution)),
      valeursEvolution: valeursParAnnee(champDe(donneesEvolution), unite),
      champGroupe: donneesGroupe != null ? champDe(donneesGroupe) : undefined,
      sousPostes: bloc.sousPostes.map((sousPoste) => ({
        cle: sousPoste.cle,
        libelle: sousPoste.libelle,
        champ: donnees != null ? donnees[sousPoste.cle] : null,
        evolution: pourcentageEvolution(donneesEvolution != null ? donneesEvolution[sousPoste.cle] : null),
        valeursEvolution: valeursParAnnee(donneesEvolution != null ? donneesEvolution[sousPoste.cle] : null, unite),
        champGroupe: donneesGroupe != null ? donneesGroupe[sousPoste.cle] : undefined
      }))
    }
  })
}

export const valeursParAnnee = (champEvolution, unite) => {
  if (champEvolution == null || champEvolution.champParAnnee == null) {
    return {}
  }
  return Object.entries(champEvolution.champParAnnee).reduce((valeurs, [annee, champ]) => {
    const montant = valeurSelonUnite(champ, unite)
    if (montant != null) {
      valeurs[annee] = montant
    }
    return valeurs
  }, {})
}

export const pourcentageEvolution = (champEvolution) => {
  if (champEvolution == null) {
    return null
  }
  const pourcentage = champEvolution.evolutionMontantEnPourcentage
  return pourcentage != null ? pourcentage : null
}

export const RESUME = [
  { cle: 'chargeVariable', cleResume: 'totalChargesVariables', libelle: 'Charges variables', operateurSuivant: 'mdi-plus', hausseFavorable: false },
  { cle: 'chargeFixe', cleResume: 'totalChargesFixes', libelle: 'Charges fixes', operateurSuivant: 'mdi-minus', hausseFavorable: false },
  { cle: 'coproduit', cleResume: 'totalCoproduits', libelle: 'Co-produits', operateurSuivant: 'mdi-minus', hausseFavorable: true },
  { cle: 'autresProduits', cleResume: 'totalAidesEtAutres', libelle: 'Aides et autres', operateurSuivant: 'mdi-equal', hausseFavorable: true }
]

export const champDuResume = (source, poste) => {
  if (source === undefined) {
    return undefined
  }
  if (source == null) {
    return null
  }
  const champ = source[poste.cleResume]
  return champ != null ? champ : null
}
